import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import * as searchActions from 'constants/searchActions';
import { splitAtCamelCase } from 'util/formatUtil';
import { getDynamicIntegrationOrderSearchOptions } from 'selectors/tools';

export const CoiOrderSearchOptions = () => {
  const dynamicIntegrationSearchOptions = useSelector(getDynamicIntegrationOrderSearchOptions);

  const emailOption = (
    <option key={searchActions.COMMON_ORDER_EMAIL} value={searchActions.COMMON_ORDER_EMAIL}>
      Get order by email
    </option>
  );

  const orderNumberOption = (
    <option key={searchActions.COMMON_ORDER_NUMBER} value={searchActions.COMMON_ORDER_NUMBER}>
      Get order by number
    </option>
  );

  const phoneNumberOption = (
    <option key={searchActions.COMMON_ORDER_PHONE_NUMBER} value={searchActions.COMMON_ORDER_PHONE_NUMBER}>
      Get order by phone number
    </option>
  );

  if (isEmpty(dynamicIntegrationSearchOptions)) {
    // Use default options if dynamic integration is not active for order searches
    return [emailOption, orderNumberOption, phoneNumberOption];
  }

  // We only support three search methods for one resource
  return dynamicIntegrationSearchOptions.slice(0, 3).map((inputArray, idx) => {
    // EX inputArray = ['customerEmail', 'zipCode']
    const optionText = inputArray.reduce((acc, option) => {
      if (!option) {
        return acc;
      }

      const optionName = splitAtCamelCase(option.varName);

      // EX -> customer email and zip code
      return acc ? `${acc} and ${optionName}` : optionName;
    }, '');

    return (
      <option
        key={`${searchActions.COMMON_ORDER_DYNAMIC_INPUT}${idx}`}
        value={`${searchActions.COMMON_ORDER_DYNAMIC_INPUT}${idx}`}
      >
        {`Get order by ${optionText}`}
      </option>
    );
  });
};
